import "./ImageSection.css";
import { MdCloudUpload, MdDelete } from "react-icons/md";

import getImageUrl from "../../../../../../../../utils/imageUrl";

function ImageSection({
  formData,
  updateField,
}) {

  const handleImageChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    updateField("image", file);
  };

const preview =
  formData.image instanceof File
    ? URL.createObjectURL(formData.image)
    : formData.image
      ? getImageUrl(`/uploads/${formData.image}`)
      : "";


  return (

    <div className="bakery-form-section">

      <h3 className="section-title">
        Product Image
      </h3>


      <div className="image-upload-container">

        {preview ? (

          <div className="image-preview">

            <img
              src={preview}
              alt="Product Preview"
              onError={(e) => {
                e.currentTarget.style.display =
                  "none";
              }}
            />

            <button
              type="button"
              className="remove-image-btn"
              onClick={() =>
                updateField("image", "")
              }
            >
              <MdDelete />
            </button>

          </div>

        ) : (

          <label className="upload-box">

            <MdCloudUpload
              className="upload-icon"
            />

            <span>
              Click to upload product image
            </span>

            <small>
              JPG, PNG, WEBP
            </small>

            <input
              type="file"
              accept="image/*"
              hidden
              onChange={handleImageChange}
            />

          </label>

        )}

      </div>

    </div>
  );
}

export default ImageSection;